import { useState } from "react";
import { toast } from "sonner";
import { Apple, CalendarSync as SyncIcon, Copy, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/kit";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const CalendarSync = () => {
  const { user } = useAuth();
  const [url, setUrl] = useState("");
  const [open, setOpen] = useState(false);
  const load = (p) => p.then((r) => setUrl(BASE + r.data.path)).catch((e) => toast.error(errMsg(e)));
  const show = () => { setOpen(true); if (!url) load(api.get("/ical/link")); };
  const regen = () => { if (window.confirm("Il vecchio link smetterà di funzionare su tutti i telefoni. Continuare?")) load(api.post("/ical/regenerate")).then(() => toast.success("Nuovo link creato")); };
  const webcal = url.replace(/^https?:/, "webcal:");
  const copy = () => navigator.clipboard.writeText(url).then(() => toast.success("Link copiato"));
  return (
    <>
      <Button variant="outline" className="rounded-full" onClick={show} data-testid="cal-sync-button"><SyncIcon size={15} className="mr-2" /> Collega a iPhone / Google</Button>
      <Modal open={open} onOpenChange={setOpen} title="Collega il calendario" testId="cal-sync-modal">
        <p className="text-sm text-[#4A6670]">Eventi, opzioni, appuntamenti, scadenze delle rate, compleanni e anniversari compaiono da soli sul calendario del telefono e si aggiornano automaticamente. Le modifiche si fanno qui nell'app.</p>
        <div className="flex gap-2 mt-3">
          <input readOnly value={url || "Caricamento…"} className="flex-1 min-w-0 text-xs rounded-md border border-[#D4E6EC] px-3 py-2 bg-[#F5FAFB]" data-testid="cal-sync-url" />
          <Button variant="outline" size="icon" onClick={copy} disabled={!url} data-testid="cal-sync-copy"><Copy size={15} /></Button>
        </div>
        <div className="grid sm:grid-cols-2 gap-3 mt-4">
          <a href={webcal} className="rounded-xl border border-[#D4E6EC] p-4 hover:bg-[#F5FAFB] transition-colors" data-testid="cal-sync-apple">
            <div className="font-semibold flex items-center gap-2"><Apple size={16} /> iPhone / Mac</div>
            <div className="text-xs text-[#7B929C] mt-1">Apri da iPhone e tocca «Abbonati». In alternativa: Impostazioni › Calendario › Account › Aggiungi calendario abbonato, e incolla il link.</div>
          </a>
          <a href={`https://calendar.google.com/calendar/r?cid=${encodeURIComponent(webcal)}`} target="_blank" rel="noreferrer" className="rounded-xl border border-[#D4E6EC] p-4 hover:bg-[#F5FAFB] transition-colors" data-testid="cal-sync-google">
            <div className="font-semibold">Google Calendar</div>
            <div className="text-xs text-[#7B929C] mt-1">Apri da computer e conferma «Aggiungi». In alternativa: Altri calendari › + › Da URL, e incolla il link.</div>
          </a>
        </div>
        <p className="text-xs text-[#7B929C] mt-3">Google aggiorna i calendari collegati ogni poche ore, iPhone circa ogni ora. Non condividere il link fuori dallo staff.</p>
        {user?.role === "admin" && <Button variant="ghost" size="sm" className="mt-2 text-[#B4553A]" onClick={regen} data-testid="cal-sync-regenerate"><RefreshCw size={14} className="mr-2" /> Rigenera link (disattiva il vecchio)</Button>}
      </Modal>
    </>
  );
};
